// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1JobSchema } from './v1/jobSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';

export const getImportJobPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  app_id: z.number().int().describe("AppUser id"),
  id: z.number().int().describe("Job id"),
});

export const getImportJobHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description Job details
 */
export const getImportJob200Schema = z.lazy(() => v1JobSchema);

/**
 * @description Job not found
 */
export const getImportJob404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const getImportJobQueryResponseSchema = z.lazy(() => getImportJob200Schema);
